import React from 'react';
import { Link } from 'react-router-dom';
import { MailIcon, PhoneIcon } from 'lucide-react';
import { liveCities, plannedCities } from '../data/cities';
const columns = [{
  heading: 'Services',
  links: [{
    label: 'Investment advisory',
    to: '/services'
  }, {
    label: 'Estate & succession',
    to: '/services'
  }, {
    label: 'Tax & structuring',
    to: '/services'
  }, {
    label: 'Insurance & risk',
    to: '/services'
  }, {
    label: 'Family governance',
    to: '/services'
  }]
}, {
  heading: 'Firm',
  links: [{
    label: 'Our approach',
    to: '/approach'
  }, {
    label: 'About & founder',
    to: '/about'
  }, {
    label: 'Insights',
    to: '/insights'
  }, {
    label: 'Locations',
    to: '/locations'
  }, {
    label: 'Get started',
    to: '/contact'
  }]
}];
export function SiteFooter() {
  return <footer className="bg-charcoal text-cream" data-id="element-168" data-mp="11qsaarmm9e0r">
      <div className="mx-auto w-full max-w-shell px-5 py-14 sm:px-8 sm:py-16" data-id="element-169" data-mp="wsh0ggwbn3ij">
        <div className="grid gap-10 border-b border-cream/12 pb-12 md:grid-cols-12" data-id="element-170" data-mp="wqe65ko4yo80">
          <div className="md:col-span-4" data-id="element-171" data-mp="15sy9ig3xjyz8">
            <div className="flex items-baseline gap-[0.15rem]" data-id="element-172" data-mp="1aq86qhxk9exm">
              <span className="font-serif text-[1.4rem] text-cream" data-id="element-173" data-mp="1anlptros5n2q">Mera</span>
              <span className="font-serif text-[1.4rem] text-gold-light" data-id="element-174" data-mp="vuifo5diqbm1">Bucket</span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-cream/60" data-id="element-175" data-mp="10tv24p0h9go3">
              Multi-family office advisory, founded in Bengaluru in 2026, with our first branch in
              Chennai. Central research, local relationships.
            </p>
            <div className="mt-6 space-y-2 text-sm text-cream/70" data-id="element-176" data-mp="1esbh138hudhb">
              <a href="tel:+918012345678" className="flex items-center gap-2 transition-colors duration-200 ease-out-quint hover:text-gold-light" data-id="element-177" data-mp="1jqmstjicmy26">
                <PhoneIcon className="h-4 w-4 text-gold-light" aria-hidden="true" data-id="element-178" data-mp="2c6xhjgquc06o" />
                +91 80 1234 5678
              </a>
              <a href="mailto:contact@merabucket.com" className="flex items-center gap-2 transition-colors duration-200 ease-out-quint hover:text-gold-light" data-id="element-179" data-mp="2m3603oi2c9ly">
                <MailIcon className="h-4 w-4 text-gold-light" aria-hidden="true" data-id="element-180" data-mp="2d16nd8e2zrot" />
                contact@merabucket.com
              </a>
            </div>
          </div>

          {columns.map(column => <div key={column.heading} className="md:col-span-2" data-id="element-181" data-mp="234tprzff0tos">
              <h2 className="font-sans text-overline font-semibold uppercase text-cream/45" data-id="element-182" data-mp="1yctl5toehclv">
                {column.heading}
              </h2>
              <ul className="mt-4 space-y-2.5" data-id="element-183" data-mp="1teicvndr7a5r">
                {column.links.map(link => <li key={link.label} data-id="element-184" data-mp="1pe84y56ei9o9">
                    <Link to={link.to} className="text-sm text-cream/75 transition-colors duration-200 ease-out-quint hover:text-gold-light" data-id="element-185" data-mp="1kdarg5wc63t3">
                      {link.label}
                    </Link>
                  </li>)}
              </ul>
            </div>)}

          <div className="md:col-span-4" data-id="element-186" data-mp="3vzco4i68uroe">
            <h2 className="font-sans text-overline font-semibold uppercase text-cream/45" data-id="element-187" data-mp="4uw1dhi02ks6">Offices</h2>
            <ul className="mt-4 flex flex-wrap gap-x-5 gap-y-2.5" data-id="element-188" data-mp="8vy1s1nnl2vq">
              {liveCities.map(city => <li key={city.name} data-id="element-189" data-mp="38buyotagc5ol">
                  <Link to="/locations" className="text-sm text-cream/85 transition-colors duration-200 ease-out-quint hover:text-gold-light" data-id="element-190" data-mp="38cwa4yvdqu6u">
                    {city.name}
                  </Link>
                </li>)}
            </ul>

            <h2 className="mt-7 font-sans text-overline font-semibold uppercase text-cream/45" data-id="element-191" data-mp="3m4ufcylz05xq">
              Opening next
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-cream/55" data-id="element-192" data-mp="2tlx703dbcxun">
              {plannedCities.map(city => city.name).join(' · ')}
            </p>
          </div>
        </div>

        <div className="flex flex-col gap-4 pt-8 text-xs leading-relaxed text-cream/45 md:flex-row md:items-start md:justify-between" data-id="element-193" data-mp="25iqyc6k1s38a">
          <p className="max-w-2xl" data-id="element-194" data-mp="2k8oogs1jf304">
            MeraBucket Wealth Advisors Pvt. Ltd. SEBI Registered Investment Adviser INA200016412 · Registered office: Bengaluru, Karnataka. Fee-only advisory - we receive no commission from any product manufacturer. Investments are subject to market risk. Past performance is not indicative of future results.
          </p>
          <p data-id="element-195" data-mp="336hfavyvzmh5">© {new Date().getFullYear()} MeraBucket</p>
        </div>
      </div>
    </footer>;
}